<div class="container-fluid bg-white vh-100 p-0">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="Mastercard Match Inquiry" />
    <div class="d-flex justify-content-center align-items-center min-vh-50">
        <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
            <div class="form-group mt-3">
                <form @submit.prevent="submit_mastercard_match_inquiry">
                    <div class="form-group col-12 mt-3">
                        <label for="merchant_name" class="fw-bold text-xs">Merchant Name</label>
                        <input type="text" v-model="form.merchant_name"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="merchant_name" required
                            placeholder="Merchant Name">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="merchant_address_line_one" class="fw-bold text-xs">Merchant Address Line 1</label>
                        <input type="text" v-model="form.merchant_address_line_one"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="merchant_address_line_one"
                            required placeholder="Address Line 1">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="merchant_address_line_two" class="fw-bold text-xs">Merchant Address Line 2</label>
                        <input type="text" v-model="form.merchant_address_line_two"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="merchant_address_line_two"
                            placeholder="Address Line 2">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="merchant_city" class="fw-bold text-xs">Merchant City</label>
                        <input type="text" v-model="form.merchant_city"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="merchant_city" required
                            placeholder="City">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="merchant_country" class="fw-bold text-xs">Merchant Country</label>
                        <input type="text" v-model="form.merchant_country"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="merchant_country" required
                            placeholder="Country">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="merchant_phone_number" class="fw-bold text-xs">Merchant Phone Number</label>
                        <input type="text" v-model="form.merchant_phone_number"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="merchant_phone_number" required
                            placeholder="Phone Number">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="merchant_category" class="fw-bold text-xs">Merchant Category</label>
                        <input type="text" v-model="form.merchant_category"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="merchant_category" required
                            placeholder="Category">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="principal_first_name" class="fw-bold text-xs">Principal First Name</label>
                        <input type="text" v-model="form.principal_first_name"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="principal_first_name" required
                            placeholder="First Name">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="principal_last_name" class="fw-bold text-xs">Principal Last Name</label>
                        <input type="text" v-model="form.principal_last_name"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="principal_last_name" required
                            placeholder="Last Name">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="principal_address_line_one" class="fw-bold text-xs">Principal Address Line 1</label>
                        <input type="text" v-model="form.principal_address_line_one"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="principal_address_line_one"
                            required placeholder="Address Line 1">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="principal_address_line_two" class="fw-bold text-xs">Principal Address Line 2</label>
                        <input type="text" v-model="form.principal_address_line_two"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="principal_address_line_two"
                            placeholder="Address Line 2">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="principal_city" class="fw-bold text-xs">Principal City</label>
                        <input type="text" v-model="form.principal_city"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="principal_city" required
                            placeholder="City">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="principal_country" class="fw-bold text-xs">Principal Country</label>
                        <input type="text" v-model="form.principal_country"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="principal_country" required
                            placeholder="Country">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="principal_phone_number" class="fw-bold text-xs">Principal Phone Number</label>
                        <input type="text" v-model="form.principal_phone_number"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="principal_phone_number"
                            required placeholder="Phone Number">
                    </div>
                    <div class="form-group col-12 mt-3">
                        <label for="principal_email" class="fw-bold text-xs">Principal Email</label>
                        <input type="email" v-model="form.principal_email"
                            class="form-control text-xs rounded-small p-3 shadow-sm" id="principal_email" required
                            placeholder="Email">
                    </div>
                    <div class="d-flex justify-content-center mb-3 mt-4">
                        <button type="submit"
                            class="btn btn-bg-green btn-sm px-4 rounded-small shadow-sm fw-bold text-xs">
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
